import i18n from 'i18next';
import { getDeviceStatusTextKey } from 'ui/shared/deviceStatus';
import { Dictionary, values } from 'lodash';
import { DeviceEvent } from 'shared/models';

export const toCsv = (input: any) => {
    if (typeof input === 'string') {
        return `"${input.replace(/"/g, '""')}"`;
    }
    return input;
};

export const makeCsv = (events: Dictionary<DeviceEvent>, deviceNameById: (id: string) => string) => {
    // TODO: translate these headers
    const header = [
        'ID',
        'Device',
        'Status',
        'Timestamp',
    ].map(toCsv).join(',');

    const lines =
        values(events).sort((a, b) => b.id - a.id).map(event => [
            event.id,
            deviceNameById(event.deviceId),
            i18n.t(getDeviceStatusTextKey(event.status)!),
            event.created,
        ].map(toCsv).join(','));

    return [ header, ...lines ].join('\r\n');
};

export const makeCsvUrl = (events: Dictionary<DeviceEvent> | null, deviceNameById: (id: string) => string) => {
    if (events) {
        const csv = makeCsv(events, deviceNameById);
        const blob = new Blob([ csv ], { type: "text/csv;charset=utf-8" });
        return window.URL.createObjectURL(blob);
    }
};

export const disposeCsvUrl = (url?: string) => {
    if (url) {
        window.URL.revokeObjectURL(url);
    }
};
